
import { db } from "../../firebaseClient";

const CONTRACTS_COL = "legal_contracts";
const APPROVALS_COL = "approval_requests";

/**
 * Finds a document ID by its unique code (e.g. Contract No, Doc Code).
 */
export async function findIdByCode(collection: string, codeField: string, codeValue: string): Promise<string | null> {
  if (!codeValue) return null;
  const snap = await db.collection(collection).where(codeField, "==", codeValue).limit(1).get();
  if (!snap.empty) {
    return snap.docs[0].id;
  }
  return null;
}

/**
 * Updates the cross-reference fields on the related document.
 * 
 * @param targetType 'archive' | 'review' | 'seal' - The type of document we want to update.
 * @param targetCode The unique code of the document we want to update (e.g. CT-2023-001).
 * @param updates A key-value pair of fields to update on the target document (e.g. { reviewCode: 'CR-...' }).
 */
export async function syncCrossReference(
  targetType: 'archive' | 'review' | 'seal', 
  targetCode: string, 
  updates: { reviewCode?: string | null; archiveCode?: string | null; sealRequestCode?: string | null }
) {
  if (!targetCode) return;

  let collection = "";
  let codeField = "";

  if (targetType === 'archive') {
    collection = CONTRACTS_COL;
    codeField = "contractNo";
  } else if (targetType === 'review') {
    collection = APPROVALS_COL;
    codeField = "docCode"; // assuming reviews use docCode
    // We also need to ensure it's a review module if needed, but docCodes usually unique enough or prefixed
  } else if (targetType === 'seal') {
    collection = APPROVALS_COL;
    codeField = "docCode";
  }

  const targetId = await findIdByCode(collection, codeField, targetCode);
  
  if (targetId) {
    console.log(`[CrossRef] Syncing ${targetType} (${targetCode}) with`, updates);
    await db.collection(collection).doc(targetId).update(updates);
  } else {
    console.warn(`[CrossRef] Target ${targetType} with code ${targetCode} not found.`);
  }
}
